/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessObjectDataStorageUnitKey } from './businessObjectDataStorageUnitKey';
import { StorageDirectory } from './storageDirectory';
import { StorageFile } from './storageFile';


export interface BusinessObjectDataStorageUnitCreateRequest { 
    businessObjectDataStorageUnitKey: BusinessObjectDataStorageUnitKey;
    storageDirectory?: StorageDirectory;
    /**
     * A container of various Storage Files that reside within a specific Storage Unit. Required when                   storageDirectory is not present. Note: storageFiles cannot be specified when discoverStorageFiles is enabled                
     */
    storageFiles?: Array<StorageFile>;
    /**
     * If true, enables the auto-discovery of all Storage Files in the specified Storage Directory                
     */
    discoverStorageFiles?: boolean;
}
